import AxiosInstance from 'src/shared/services/axios/interceptor';
import { GroupMessageResponse } from 'src/modules/groupMessageEmail/models/groupMessageResponse';
import { Selection } from 'src/modules/groupMessageEmail/models/selection';
import { FixedSelection } from 'src/modules/groupMessageEmail/models/fixedSelection';
import { PagedResult } from 'src/shared/models/pagedResult';
import { setPagingParams } from 'src/shared/functions/createPagingParams';
import { GroupMessageRequestPost } from 'src/modules/groupMessageEmail/models/groupMessageRequestPost';
import { GroupMessageRequestPut } from 'src/modules/groupMessageEmail/models/groupMessageRequestPut';
import { ComposeEmail } from 'src/modules/groupMessageEmail/models/composeEmail';
import { GroupMessageEmailSearchFilter } from 'src/modules/groupMessageEmail/models/groupMessageEmailSearchFilter';
import { GroupMessagePreviewPost } from 'src/modules/groupMessageEmail/models/groupMessagePreviewPost';
import { GroupMessagePreviewPut } from 'src/modules/groupMessageEmail/models/groupMessagePreviewPut';
import { GroupMessageEmailTemplate } from 'src/modules/groupMessageEmail/models/groupMessageEmailTemplate';
import { GroupMessageEmailTemplateRequest } from 'src/modules/groupMessageEmail/models/groupMessageEmailTemplateRequest';
import { ContactUnsubscriptionResponse } from 'src/modules/groupMessageEmail/models/contactUnsubscriptionResponse';
import ConsoleHelper from '../functions/consoleHelper';
import { createFormData } from '../functions/createFormData';

const selectionController = 'Selection';
const fixedSelectionController = 'FixedSelection';
const groupMessageController = 'GroupMessage';
const contactUnsubscriptionController = 'ContactUnsubscription';

export const getAllSelections = (pageIndex, pageSize, sortCol, sortDir) => {
  const endpoint = `${selectionController}/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}`;
  return AxiosInstance.get<PagedResult<Selection>>(endpoint);
};

export const getSelectionById = (id) => {
  const endpoint = `${selectionController}/${id}`;
  return AxiosInstance.get<Selection>(endpoint);
};

export const getAllFixedSelections = (pageIndex, pageSize, sortCol, sortDir) => {
  const endpoint = `${fixedSelectionController}/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}`;
  return AxiosInstance.get<PagedResult<FixedSelection>>(endpoint);
};

export const getFixedSelectionById = (id) => {
  const endpoint = `${fixedSelectionController}/${id}`;
  return AxiosInstance.get<FixedSelection>(endpoint);
};

export const getAllGroupMessages = (pageIndex, pageSize, sortCol, sortDir, searchFilter: GroupMessageEmailSearchFilter) => {
  let endpoint = `${groupMessageController}/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}`;
  endpoint += searchFilter.searchString ? `&filter=${searchFilter.searchString}` : '';
  endpoint += searchFilter.isSent !== undefined ? `&isSent=${searchFilter.isSent}` : '';
  endpoint += searchFilter.archivedMessages !== undefined ? `&isDeleted=${searchFilter.archivedMessages}` : '';
  return AxiosInstance.get<PagedResult<GroupMessageResponse>>(endpoint);
};

export const updateGroupMessage = (data: GroupMessageRequestPut) => {
  const formData = createFormData<GroupMessageRequestPut>(data);
  return AxiosInstance.put(groupMessageController, formData);
};

export const copyGroupMessage = (id) => {
  return AxiosInstance.put(`${groupMessageController}/copy/${id}`);
};

export const archiveGroupMessage = (id) => {
  return AxiosInstance.put(`${groupMessageController}/${id}/archive`);
};

export const undoArchiveGroupMessage = (id) => {
  return AxiosInstance.put(`${groupMessageController}/${id}/unArchive`);
};

export const getGroupMessageById = (id) => {
  const endpoint = `${groupMessageController}/${id}`;
  return AxiosInstance.get<GroupMessageResponse>(endpoint);
};

export const createGroupMessage = (data: GroupMessageRequestPost) => {
  const formData = createFormData<GroupMessageRequestPost>(data);
  ConsoleHelper.log('createGroupMessage', formData);
  return AxiosInstance.post('GroupMessage', formData);
};

export const sendGroupMessage = (data: ComposeEmail) => {
  const formData = createFormData<ComposeEmail>(data);
  ConsoleHelper.log('createGroupMessage', formData);
  return AxiosInstance.post('GroupMessage', formData);
};

export const previewGroupMessage = (data: GroupMessagePreviewPost) => {
  const formData = createFormData<GroupMessagePreviewPost>(data);
  return AxiosInstance.post('GroupMessage/Preview', formData);
};

export const updatePreviewGroupMessage = (data: GroupMessagePreviewPut) => {
  const formData = createFormData<GroupMessagePreviewPut>(data);
  return AxiosInstance.put('GroupMessage/Preview', formData);
};

export const getAllGroupMessageEmailTemplates = () => {
  const endpoint = `${groupMessageController}/EmailTemplate`;
  return AxiosInstance.get<GroupMessageEmailTemplate[]>(endpoint);
};

export const getGroupMessageEmailTemplateById = (id: number) => {
  const endpoint = `${groupMessageController}/EmailTemplate/${id}`;
  return AxiosInstance.get<GroupMessageEmailTemplate>(endpoint);
};

export const getGroupMessageEmailTemplateByName = (name: string) => {
  const endpoint = `${groupMessageController}/EmailTemplate/${name}`;
  return AxiosInstance.get<GroupMessageEmailTemplate>(endpoint);
};

export const CreateGroupMessageEmailTemplate = (data: GroupMessageEmailTemplateRequest) => {
  const endpoint = `${groupMessageController}/EmailTemplate`;
  return AxiosInstance.post(endpoint, data);
};

export const getContactUnsubscriptions = (
  pageIndex: number,
  pageSize: number,
  filter: string | undefined,
  type: string | undefined,
  sortCol = 'unsubscribedAt',
  sortDir = 'desc',
) => {
  let endpoint = `${contactUnsubscriptionController}/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}`;
  if (filter) endpoint += `&filter=${encodeURIComponent(filter)}`;
  if (type) endpoint += `&type=${type}`;
  return AxiosInstance.get<PagedResult<ContactUnsubscriptionResponse>>(endpoint);
};

export const deleteContactUnsubscription = (value: string, type: string) => {
  return AxiosInstance.delete(`${contactUnsubscriptionController}/by-contact?value=${encodeURIComponent(value)}&type=${type}`);
};
